import { Base } from '@studiometa/js-toolkit';
import { addClass, removeClass } from '@studiometa/js-toolkit/utils';
import Menu from './Menu.js';
import { gsap } from 'gsap';
import { Flip } from 'gsap/Flip.js';

gsap.registerPlugin(Flip);

/**
 * Header component
 * Gère le sticky header et le déplacement du logo centré sur la home.
 */
export default class Header extends Base {
  logoMoved = false;
  isSticky = false;

  /**
   * Component Configuration
   */
  static config = {
    name: 'Header',
    refs: ['logo'],
    options: {
      isHome: Boolean,
    },
    components: {
      Menu,
    },
  };

  /**
   * Mounted lifecycle hook.
   */
  mounted() {
    // Sur la home, récupérer le logo centré
    if (this.$options.isHome) {
      this.homeLogo = document.querySelector('#home-logo-icon');
      this.homeLogoContainer = document.querySelector('#homeLogoContainer');
    }

    if (scrollY > 50) {
      this.isSticky = true;
      addClass(document.documentElement, 'is-sticky');

      // Si on charge la page avec du scroll, déplacer le logo immédiatement
      if (this.$options.isHome && this.homeLogo && !this.logoMoved) {
        this.$refs.logo.append(this.homeLogo);
        this.logoMoved = true;
      }
    }
  }

  /**
   * Service scrolled hook
   * @see https://js-toolkit.studiometa.dev/api/methods-hooks-services.html#scrolled
   * @param {object} props Props
   * @param {number} props.y The current vertical scroll position.
   */
  scrolled({ y }) {
    // Gestion du logo centré uniquement sur la home
    if (this.$options.isHome && this.homeLogo) {
      if (y > 50 && !this.logoMoved) {
        this.state = Flip.getState(this.homeLogo);
        this.$refs.logo.append(this.homeLogo);
        Flip.from(this.state, {
          absolute: true,
          width: 'auto',
          yPercent: 0,
          xPercent: 0,
          duration: 0.8,
          clearProps: 'transform',
          parseTransform: true,
          ease: 'power4.inOut',
        });
        this.logoMoved = true;
      }

      if (y === 0 && this.logoMoved) {
        this.state = Flip.getState(this.homeLogo);
        this.homeLogoContainer.append(this.homeLogo);
        Flip.from(this.state, {
          absolute: false,
          width: '300px',
          yPercent: 0,
          xPercent: 0,
          duration: 0.8,
          ease: 'power4.inOut',
        });
        this.logoMoved = false;
      }
    }

    // Gestion du sticky header
    if (y > 0 && !this.isSticky) {
      addClass(document.documentElement, 'is-sticky');
      this.isSticky = true;
    }

    if (y === 0 && this.isSticky) {
      removeClass(document.documentElement, 'is-sticky');
      this.isSticky = false;
    }
  }
}
